import { render, staticRenderFns } from "./TransfersReport.vue?vue&type=template&id=e0d0a45a&scoped=true&"
import script from "./TransfersReport.vue?vue&type=script&lang=js&"
export * from "./TransfersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d0a45a",
  null
  
)

export default component.exports